import React from 'react';
import classNames from 'classnames';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { ResultType } from 'twain-sport-fe-mono/enums';
import { IStandingsMatchParticipant, IStandingsParticipant } from 'twain-sport-fe-mono/interfaces';
import { Avatar } from '../../Avatar';
import classes from './StandingsMatchParticipant.module.scss';

interface IProps {
    participantInfo: IStandingsParticipant;
    participant: IStandingsMatchParticipant;
}

export const StandingsMatchParticipantFull: React.FC<IProps> = (props) => (
    <div className={classNames(classes.container, classes.full)}>
        <span className={classes.group}>
            {!!props.participantInfo &&
                `${translationProvider.groupNames(props.participantInfo.group)}${
                    props.participantInfo.groupPosition
                }`}
        </span>
        <div className={classes.avatar}>
            {!!props.participantInfo && (
                <Avatar src={props.participantInfo.avatarPictureUrl} size="small" />
            )}
        </div>
        <span className={classes.nickname}>
            {props.participantInfo?.nickname ? (
                <strong>{props.participantInfo.nickname}</strong>
            ) : (
                translationProvider.string('tbd')
            )}
        </span>
        <span
            className={classNames(classes.point, {
                [classes.winner]: props.participant?.result === ResultType.WON,
            })}
        >
            {props.participant?.result ? props.participant.points : '-'}
        </span>
    </div>
);
